import { useState } from 'react';
import moment from "moment-jalaali";
import './ticket.css'

export default function Ticket({ showticket, setShowticket }) {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (message.trim()) {
          const date = moment().format("jYYYY/jMM/jDD");
          const time = moment().format("HH:mm:ss");
    
          const newMessage = { name, message, date, time };
    
          try {
            await fetch("http://185.164.73.170:5001/api/messages", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(newMessage),
            });
            setMessage("");
            setName("");
          } catch (error) {
            console.error("خطا در ارسال پیام", error);
          }
        }
      };
    return (
        <div className="ticketbox" style={{right: showticket ? '5px' : '-250px'}}>
            <form onSubmit={handleSendMessage}>
                <div className="ticketbox-header">
                    <h1>ارسال تیکت</h1>
                </div>
                <input value={name} type="text" placeholder="نام و نام خانوادگی" required onChange={(e) => setName(e.target.value)} maxLength={25}/>
                <textarea value={message} type="text" placeholder="متن پیام" required onChange={(e) => setMessage(e.target.value)} maxLength={200}/>
                <button type="submit">ارسال</button>
            </form>
        </div>
    )
}